// extracted by mini-css-extract-plugin
module.exports = {"logo":"LoginHeader_logo__1lMR7","title":"LoginHeader_title__1ttPk","additionalTextInHeader":"LoginHeader_additionalTextInHeader__1_G06"};